import { render, staticRenderFns } from "./RejectionReasons.vue?vue&type=template&id=41316ba1&"
import script from "./RejectionReasons.vue?vue&type=script&lang=js&"
export * from "./RejectionReasons.vue?vue&type=script&lang=js&"
import style0 from "./RejectionReasons.vue?vue&type=style&index=0&id=41316ba1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports